"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Login = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Login = require("./Login.styles");
var _Login2 = require("./Login.labels");
var _LoginBtn = require("./partials/LoginBtn");
var _Purchase = require("./partials/Purchase");
var _hooks = require("../../hooks");
var _Title = require("../../UI/Title");
var _Modal = require("../../Layout/Modal");
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
var _idmLogo = _interopRequireDefault(require("./resources/idmLogo.png"));
var _cetLogo_all = _interopRequireDefault(require("./resources/cetLogo_all.svg"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const Login = props => {
  const getLabel = (0, _hooks.useLabels)({
    labels: _Login2.labels
  });
  const {
    layout = 'popup',
    isWithCloseButton = true,
    onClose,
    isWithPurchase = false,
    purchaseTitle,
    purchaseImage,
    purchaseButtonLabel = getLabel('purchase_default_btn_label'),
    purchaseButtonUrl,
    purchaseImageAlt
  } = props;
  const {
    language
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const styles = (0, _Login.useStyles)(props);
  const [isPopupOpen, setIsPopupOpen] = (0, _react.useState)(true);
  const cetLogo = {
    he: _cetLogo_all.default,
    ar: _cetLogo_all.default,
    en: _cetLogo_all.default
  };
  const handleClose = event => {
    setIsPopupOpen(false);
    if (onClose) {
      onClose(event);
    }
  };
  const handleLoginMoe = () => {
    window.cet.accessmanagement.loginMoe(window.location.href, false, language);
  };
  const handleLoginCet = () => {
    window.cet.accessmanagement.loginCet(window.location.href, false, language);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: styles['cc-Login'],
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal, {
      layout: layout,
      isOpen: isPopupOpen,
      onClose: handleClose,
      isWithCloseButton: isWithCloseButton,
      width: isWithPurchase ? 773 : 500,
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: styles['cc-Login__content'],
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("section", {
          className: styles['cc-Login__login-section'],
          children: [isWithPurchase && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: styles['cc-Login__title-purchase'],
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Title.Title, {
              level: 3,
              color: "#fff",
              children: getLabel('purchase_login_subTitle')
            })
          }), !isWithPurchase && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: styles['cc-Login__title_container'],
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h1", {
              children: getLabel('login_welcome_title')
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
              children: getLabel('login_welcome_subtitle')
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: styles['cc-Login__buttons'],
            children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_LoginBtn.LoginBtn, {
                className: styles['cc-Login__idm_btn'],
                onClick: handleLoginMoe,
                imgSrc: _idmLogo.default,
                imgLabel: getLabel('login_idm_alt'),
                textLabel: getLabel('login_idm_btn')
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                className: styles['cc-Login__idm_desc'],
                children: getLabel('login_idm_desc')
              })]
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_LoginBtn.LoginBtn, {
              className: styles['cc-Login__cet_btn'],
              onClick: handleLoginCet,
              imgSrc: cetLogo[language],
              imgLabel: getLabel('login_cet_alt'),
              textLabel: getLabel('login_cet_btn')
            })]
          })]
        }), isWithPurchase && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Purchase.Purchase, {
          title: purchaseTitle,
          image: purchaseImage,
          buttonLabel: purchaseButtonLabel,
          buttonUrl: purchaseButtonUrl,
          imageAlt: purchaseImageAlt
        })]
      })
    })
  });
};
exports.Login = Login;